import { createFileRoute } from '@tanstack/react-router';

import { CrmCustomerLearningRoute } from '../learning';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/'
)({
  component: CrmCustomerLearningRoute,
});
